<template>
  <default-modal
    v-model="modalOpened"
    name="add-address-modal"
    :autofocus="$refs.address"
    :successHandler="handleCreate"
    :title="$t('add_address')"
  >
    <address-input
      ref="address"
      slot="content"
      v-model="formData.address"
      expanded
      required
    />
  </default-modal>
</template>

<script>
  import AddressInput from 'components/Common/Addressing/AddressInput.vue'
  import CustomerAddress from 'src/utils/SubResources/CustomerAddress'
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import changeCase from 'change-case-object'
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapActions } from 'vuex'

  function initialState () {
    return {
      address: CustomerAddress.empty()
    }
  }

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        modalOpened: false,
        formData: initialState()
      }
    },

    props: {
      customer: {
        required: true,
        type: Object
      }
    },

    computed: {
      type () {
        return this.customer.type
      }
    },

    methods: {
      ...mapActions(['createCustomerAddress']),

      open () {
        this.modalOpened = true
      },

      handleCreate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.createAddress()
          })
      },

      createAddress () {
        let data = changeCase.snakeCase(this.formData.address)

        this.createCustomerAddress({ customerId: this.customer.id, type: this.type, data })
          .then(() => {
            this.modalOpened = false
            this.$emit('reFetchCustomer')
            this.resetData()
            this.$q.notify({ message: this.$t('address_created'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      },

      resetData () {
        this.formData = initialState()
      }
    },

    components: {
      AddressInput,
      DefaultModal
    }
  }
</script>
